<template>
  <div v-if="datacollection" class="vacancy-stat">
    <FacebookStatChart
      :chart-data="datacollection"
      :height="175"
    ></FacebookStatChart>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import FacebookStatChart from "./FacebookStatChart";

export default {
  components: {
    FacebookStatChart
  },
  props: {
    id: { type: [Number, String], required: true }
  },
  data() {
    return {
      datacollection: null
    };
  },
  apollo: {
    faceBookAdInsight: {
      query: gql`
        query FaceBookAdInsight($id: ID!, $datapointStart: Time!) {
          faceBookAdInsight(id: $id) {
            id
            datapoints(from: $datapointStart) {
              date
              clicks
              spend
              cpC
            }
          }
        }
      `,
      variables() {
        return {
          id: this.id,
          datapointStart: moment().subtract(7, "days")
        };
      }
    }
  },
  watch: {
    faceBookAdInsight(stats) {
      if (!stats.datapoints) {
        this.datacollection = null;
        return;
      }

      stats.datapoints.sort((a, b) =>
        a.date > b.date ? 1 : a.date < b.date ? -1 : 0
      );

      let labels = [];
      for (let data of stats.datapoints) {
        let date = moment(data.date);
        if (labels.findIndex(val => val.diff(date) === 0) === -1) {
          labels.push(date);
        }
      }

      let clicksData = [];
      let spendData = [];
      let cpCData = [];
      for (let label of labels) {
        let clicks = 0;
        let spend = 0;
        let cpC = 0;
        for (let data of stats.datapoints) {
          let time = moment(data.date);
          if (time.diff(label) === 0) {
            clicks = data.clicks;
            spend = data.spend;
            cpC = data.cpC;
          }
        }

        clicksData.push(clicks);
        spendData.push(spend);
        cpCData.push(cpC);
      }

      this.datacollection = {
        labels,
        datasets: [
          {
            label: "Klicks",
            borderColor: "#13358e",
            data: clicksData,
            fill: true,
            backgroundColor: "#13358e",
            pointHoverBackgroundColor: "#000000"
          },
          {
            label: "Ausgegeben",
            borderColor: "#55c400",
            data: spendData,
            fill: true,
            backgroundColor: "#55c400",
            pointHoverBackgroundColor: "#000000"
          },
          {
            label: "CPC",
            borderColor: "#d1232b",
            data: cpCData,
            fill: true,
            backgroundColor: "#d1232b",
            pointHoverBackgroundColor: "#000000"
          }
        ]
      };
    }
  }
};
</script>
